// src/lib/query-keys.ts

/**
 * Factory for TanStack Query keys scoped to a module.
 * Usage:
 *   export const orgsKeys = makeQueryKeys('organizations');
 *   useQuery({ queryKey: orgsKeys.list(params), queryFn: ... })
 *   queryClient.invalidateQueries({ queryKey: orgsKeys.all() })
 */
export function makeQueryKeys<M extends string>(module: M) {
  return {
    all: () => [module] as const,
    lists: () => [module, 'list'] as const,
    list: (params: unknown) => [module, 'list', params] as const,
    details: () => [module, 'detail'] as const,
    detail: (id: string) => [module, 'detail', id] as const,
    operation: (op: string, params?: unknown) =>
      (params === undefined ? [module, op] : [module, op, params]) as readonly unknown[],
  };
}
